<template>
  <div class="login-body">
    <div class="login-container">
      <div class="login-content forget-content">
        <el-dropdown @command="changeLanguage" style="margin-left:80%;">
          <span class="el-dropdown-link">
            {{ this.language }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
            <el-dropdown-item command="en-US">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="log-icon-box forget-icon-box">
          <img src="../../assets/img/Fill38@2x.png" />
          <div class="title">{{ $t("m.login.sysName") }}</div>
        </div>
        <div class="log-type-box">
          <div class="flex flex-center header-common">
            <span
              class="header-span"
              :class="{ 'header-span-active': active == 1 }"
              @click="active = 1"
              >{{ $t("m.login.phoneValid") }}</span
            >
            <span
              class="header-span"
              :class="{ 'header-span-active': active == 2 }"
              @click="active = 2"
              >{{ $t("m.login.emailValid") }}</span
            >
          </div>
        </div>
        <el-form
          ref="elForm"
          :model="formData"
          :rules="rules"
          size="medium"
          label-width="100px"
          class="login-form"
          label-position="left"
        >
          <div class="log-input-box" v-if="active == 1">
            <el-form
              ref="mobileForm"
              :model="formData"
              :rules="rules"
              size="medium"
              label-width="100px"
              label-position="left"
            >
              <el-input
                type="text"
                v-model="formData.mobile"
                :placeholder="$t('m.login.placeholder.phone')"
              ></el-input>
              <div class="code-box">
                <el-input
                  v-model="formData.code"
                  :placeholder="$t('m.login.placeholder.code')"
                ></el-input>
                <el-button @click="getCode" type="primary">{{
                  $t("m.login.getCode")
                }}</el-button>
              </div>
              <el-input
                v-model="formData.password"
                :placeholder="$t('m.login.placeholder.password')"
              ></el-input>
              <el-input
                v-model="formData.checkPassword"
                :placeholder="$t('m.login.placeholder.password2')"
              ></el-input>
            </el-form>
          </div>
          <div class="log-input-box" v-if="active == 2">
            <el-form
              ref="emailForm"
              :model="formData"
              :rules="rules"
              size="medium"
              label-width="100px"
              label-position="left"
            >
              <el-input
                type="text"
                v-model="formData.email"
                :placeholder="$t('m.login.placeholder.email')"
              ></el-input>
              <div class="code-box">
                <el-input
                  v-model="formData.code"
                  :placeholder="$t('m.login.placeholder.code')"
                ></el-input>
                <el-button type="primary" @click="getEmailCode" slot="append">{{
                  $t("m.login.getEmailCode")
                }}</el-button>
              </div>
              <el-input
                v-model="formData.password"
                :placeholder="$t('m.login.placeholder.password')"
                clearable
                show-password
              ></el-input>
              <el-input
                v-model="formData.checkPassword"
                :placeholder="$t('m.login.placeholder.password2')"
                clearable
                show-password
              ></el-input>
            </el-form>
          </div>
          <div class="log-rem-box">
            <div class="rem-right">
              <span @click="routerLink('register')" class="register-btn">
                {{ $t("m.login.register") }}</span
              >
              <span @click="routerLink('login')">{{
                $t("m.login.login")
              }}</span>
            </div>
          </div>
          <div class="log-btn-box">
            <el-button type="warning" @click="submitForm">{{
              $t("m.button.save")
            }}</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      active: 1,
      formData: {
        mobile: undefined,
        email: undefined,
        username: undefined,
        password: undefined,
        code: undefined,
        checkPassword: "",
      },
      activeName: "code",
      rememberMe: false,
      rules: {
        mobile: [
          {
            required: true,
            message: this.$t("m.login.placeholder.phone"),
            trigger: "blur",
          },
          {
            pattern: /^1(3|4|5|7|8|9)\d{9}$/,
            message: this.$t("m.login.phoneError"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("m.login.placeholder.email"),
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: this.$t("m.login.emailError"),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: this.$t("m.login.placeholder.code"),
            trigger: "blur",
          },
        ],
        username: [
          {
            required: true,
            message: this.$t("m.login.placeholder.userName"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("m.login.placeholder.password"),
            trigger: "blur",
          },
        ],
        checkPassword: [
          {
            required: true,
            message: this.$t("m.login.placeholder.password2"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    routerLink(type) {
      if (type == "register") {
        this.$router.push("/register").catch((err) => {
          console.info(err);
        });
      } else if (type == "login") {
        this.$router.push("/login").catch((err) => {
          console.info(err);
        });
      } else {
        this.$router.push("/forget").catch((err) => {
          console.info(err);
        });
      }
    },

    submitForm() {
      if (this.formData.password.length < 8) {
        this.$message.error(
          this.$i18n.locale === "en-US"
            ? "Please agree to the 'Software Use Agreement'"
            : "密码长度不能小于8位"
        );
        return;
      }
      if (this.formData.password != this.formData.checkPassword) {
        this.$message.error(
          this.$i18n.locale === "en-US"
            ? "Confirm that the password is different from the password'"
            : "确认密码和密码不同"
        );
        return;
      }
      this.$refs["elForm"].validate((valid) => {
        if (!valid) return;
        // TODO 提交表单
        this.forgetPassword();
      });
    },
    resetForm() {
      this.$refs["elForm"].resetFields();
    },
    getCode() {
      let params = new URLSearchParams();
      params.append("phone", this.formData.mobile);
      this.$http
        .post("/manage/user/sendCode.do", params)
        .then(
          function(resp) {
            console.info(resp);
            if (resp.data.success) {
              this.$message.success(this.$t("m.alert.codeSuccess"));
            } else {
              this.$message.error(resp.data.msg);
            }
          }.bind(this)
        )
        .catch(function(err) {
          console.error(err);
        });
    },
    getEmailCode() {
      let params = new URLSearchParams();
      params.append("email", this.formData.email);
      this.$http
        .post("/manage/user/sendEmail.do", params)
        .then(
          function(resp) {
            console.info(resp);
            if (resp.data.success) {
              this.$message.success(this.$t("m.alert.codeSuccess"));
            } else {
              this.$message.error(resp.data.msg);
            }
          }.bind(this)
        )
        .catch(function(err) {
          console.error(err);
        });
    },
    forgetPassword() {
      let params = new URLSearchParams();
      let url = "";
      if (this.active == 1) {
        url = "/manage/user/forget.do";
        params.append("phone", this.formData.mobile);
      } else if (this.active == 2) {
        url = "/manage/user/forgetEmail.do";
        params.append("email", this.formData.email);
      }
      params.append("code", this.formData.code);
      params.append("passwordNew", this.formData.password);
      this.$http
        .post(url, params)
        .then(
          function(resp) {
            console.info(resp);
            if (resp.data.success) {
              this.$message.success(this.$t("m.alert.codeResetSuccess"));
              this.$router.push("/login");
            } else {
              this.$message.error(resp.data.msg);
            }
          }.bind(this)
        )
        .catch(function(err) {
          console.error(err);
        });
    },
  },
};
</script>
<style scoped lang="scss">
.forget-content {
  padding-top: 160px !important;
}
.forget-icon-box {
  top: 30px !important;
}
</style>
